import React, { memo, useEffect, useState } from 'react';
import './Footer.css';
import { LoginService } from './services/LoginService';

export const Footer = () => {
  const [version, setVersion] = useState('');
  const [presents, setPresents] = useState('2024-2025');

  useEffect(() => {
    const loadFooter = async () => {
      try {
        const payload = { projectname: 'GearForNeed-REACT' };
        const footerinfo = await LoginService.getFooter1(payload);

        setVersion(footerinfo[0].version);
        setPresents(footerinfo[0].present);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    loadFooter();
  }, []);

  return (
    <footer className="app-footer main-footer">
      <div className="app-footer__inner">
        <div className="app-footer__meta">
          <span>Copyright © ({presents}) GearForNeed.</span>
          <span>All Rights Reserved.</span>
          <span>Version: {version}</span>
        </div>
        <div className="app-footer__links">
          <a href="https://devreactgearforneed.net/privacy.html" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <a href="https://devreactgearforneed.net/termsandconditions.html" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>
          <a href="https://devreactgearforneed.net/" target="_blank" rel="noopener noreferrer">
            Jayson & Williams Technologies, INC
          </a>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
